import React from 'react';
import { Actions } from '../../store/actions/facilityActions';
import { connect } from 'react-redux';

import { RowBtn } from '../../styledComponents/GlobalStyle';

const FacilityRow = ({ facilityDetails, showFacilitiesDeleteModal, facilityTypes, canDelete }) => {
  return (
    <tr>
      <td style={{ textAlign: 'left' }}>{facilityDetails?.name}</td>
      <td>{facilityTypes?.find((f) => f.id === facilityDetails?.facilityTypeId)?.name}</td>
      <td>{facilityDetails?.isPrimary === true ? 'Yes' : 'No' || 'N/A'}</td>
      <td>{facilityDetails?.postCode}</td>
      <td>{facilityDetails?.externalId}</td>
      <td>{facilityDetails?.facilityM2}</td>
      <td>
        <RowBtn id='Facility-view-edit' to={`/facilities/${facilityDetails.id}`} className='view-edit-button'>
          View/Edit
        </RowBtn>
      </td>
      <td>
        {canDelete && (
          <i
            id='deleteFacilityBtn'
            style={{ cursor: 'pointer' }}
            onClick={() => showFacilitiesDeleteModal(true, facilityDetails)}
            className='fa fa-trash-o fa-lg'
          />
        )}
      </td>
    </tr>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    facilityModal: state.facility?.facilitiesDeleteModal,
    facilityTypes: state?.facility?.types,
    canDelete:
      (state?.organisation?.permissions?.facilities?.[ownProps.facilityDetails.id]?.delete ??
        state?.organisation?.permissions?.facilities?.['*']?.delete) ||
      false,
  };
};

const mapDispatchToProps = (dispatch) => ({
  showFacilitiesDeleteModal: (status, item) => dispatch(Actions.showFacilitiesDeleteModal(status, item)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FacilityRow);
